import unlockedFeaturesDataset from "../datasets/unlocked_features_dataset";
import checkIfEligibleForUnlockedFeature from "./check_if_eligible_for_unlocked_feature";

export const reconcileUnlockedFeatures = (gameMonths, cashAmt, monthlyIncome, unlockedFeatures, activeFeatureArr,
    totalNbrGameMonths, annualSalary, creditReport) => {
    let deleteFeatureArr = [];
    let unlockedFeaturesList = JSON.parse(JSON.stringify(unlockedFeaturesDataset));
    unlockedFeaturesList = (unlockedFeaturesList).sort((a, b) => 
        (a.featureName + a.level > b.featureName + b.level) ? -1 : 1);
    let gameMonthsPlayed = +totalNbrGameMonths - +gameMonths;
    let changed = false; 
    for (let i=0; i<unlockedFeaturesList.length; i++){
        let featureName = unlockedFeaturesList[i].featureName; 
        let unlockedFeatureObj = unlockedFeatures.find(elem => elem.featureName === featureName);
        
        const eligibleForFeature = checkIfEligibleForUnlockedFeature(gameMonthsPlayed, cashAmt, monthlyIncome,
            annualSalary, unlockedFeaturesList[i], unlockedFeatureObj, creditReport);
        const activeFeatureObj = activeFeatureArr.find(elem => elem.featureName === featureName);
        let activeFeatureLevel = 0;
        if (activeFeatureObj ){
            activeFeatureLevel = +activeFeatureObj.level;
        } 
        if (eligibleForFeature){
            //   this means the feature has been earned 
            if (!unlockedFeatureObj){
                const newUnlockedFeature = {featureName: unlockedFeaturesList[i].featureName, 
                    setup: "none", level: unlockedFeaturesList[i].level}
                changed = true;
                unlockedFeatures.push(newUnlockedFeature);
            }else{
                if (unlockedFeaturesList[i].level > unlockedFeatureObj.level &&
                    unlockedFeaturesList[i].level > activeFeatureLevel ){
                    changed = true;
                    // if the previous level of the feature has never been accepted, then change level number
                    //      but no new notification will happen
                    // if the previous level of the feature has been activated, the level will change and  
                    //      setup will be set to "none" - this will force a notification but will not affect the
                    //      previous level's information.
                    unlockedFeatureObj.level = unlockedFeaturesList[i].level;
                    unlockedFeatureObj.setup = "none";
                }
            }
        }else{
            // only change if level being checked is the same as the current unlocked feature
            if (unlockedFeatureObj && unlockedFeatureObj.level === unlockedFeaturesList[i].level){
                // if the feature is currently active, no update is done even if no longer eligible
                if (unlockedFeatureObj  &&
                    +activeFeatureLevel === unlockedFeatureObj.level){
                        // even if no longer eligible, if the feature has been activated then it should
                        // remain active - following is to ensure unlocked feature table is in-sync with
                        // active features (probably not needed)
                        if (unlockedFeatureObj.setup !== "active"){
                            unlockedFeatureObj.setup = "active";
                            changed = true;
                        }
                }
                if (unlockedFeatureObj  &&
                    unlockedFeaturesList[i].level === unlockedFeatureObj.level &&
                    unlockedFeatureObj.setup !== "active"){
                        changed = true;
                        if (activeFeatureLevel === 0 &&
                            unlockedFeatureObj.level === 1){
                            //  this feature should be deleted from unlockedFeatures table
                            deleteFeatureArr.push(featureName);
                        }else{      
                            if (activeFeatureObj  && 
                                unlockedFeatureObj.setup !== "active"){
                                    unlockedFeatureObj.level = activeFeatureLevel;
                                    unlockedFeatureObj.setup = "active";
                            }
                            //  if player is no longer eligible for this feature/level and the feature
                            //  has not already been activated, then downgrade level or remove the 
                            //  table entry
                            unlockedFeatureObj.level = activeFeatureLevel;
                        }
                }
            }
        }
    }
  
    if (deleteFeatureArr.length !== 0){
        const startIdx = unlockedFeatures.length - 1;
        for (let i=startIdx; i>=0; i--){
             const featureName = unlockedFeatures[i].featureName;
             if (deleteFeatureArr.includes(featureName)){
                 unlockedFeatures.splice(i,1);
             }
        }
 }
    
    let featureObj = {unlockedFeatures: unlockedFeatures, changed: changed};
    return featureObj;
   
}

export default reconcileUnlockedFeatures;
